$(function() {
	var firstLoad = true;

	$('.tab a').on('click', function(event) {
	    if (!$(this).hasClass('direct')) {
            event.preventDefault();
            if (!$(this).hasClass('active')) {

				$(this).parents('mxm_tabs').find('.tab a').removeClass('active');
                $(this).addClass('active');

                if (!firstLoad) {
                    $('.filter-tab-content').fadeOut('fast');
                } else {
                    firstLoad = !firstLoad;
                }

                var tab = $(this).attr('href');
                $(tab).fadeIn();
            }
        }
	});

	var hash = window.location.hash.substr(1);

	if (hash) {
		var $link = $( 'a[href="#'+hash+'"]' );

		firstLoad = true;
		$link.click();
		// $('.filter-tab-content').show();

		// $('.tab a').removeClass('active');
		// $link.addClass('active');
		//
		var tab = $link.attr('href');
		$(tab).show();
	}
});


/** WEBPACK FOOTER **
 ** ./Frontend/js/modules/tabs/index.js
 **/